// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentContentTwoColumnsFragmentDoc = gql`
    fragment componentContentTwoColumns on ComponentContentTwoColumns {
  leftColumnBackgroundColor
  leftColumnContent {
    ...contentComponentItem
  }
  rightColumnBackgroundColor
  rightColumnContent {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;